<template>
    <el-card shadow="hover">
        <label slot="header">菜单</label>
        需要往store.js注入JMenu模块
        import { JMenu } from './components/JMenu/store'
        <el-divider content-position="left">j-menu mode默认vertical  自动压缩屏幕尺寸collapseWidth：1280</el-divider>
        <div style="max-width: 200px;">
            <j-menu />
        </div>
        <el-divider content-position="left">mode="horizontal"</el-divider>
        <j-menu mode="horizontal" />
    </el-card>
</template>

<script>
    import JMenu from "./JMenu";
    export default {
        components: {
            JMenu
        },
        data() {
            return {}
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>
